<template>
  <div>
    <div class="school-map-wrapper" id="school-map-wrapper">
      <SchoolMapSearch />
      <SchoolMapView v-show="switchMapList" :key="this.$store.state.mapKey" />
      <SchoolListView v-show="!switchMapList"/>
      <SchoolCompare
        :schools="fetchedSchools"
        v-if="showCompare"/>

      <!-- Mobile -->
      <div v-show="isMobile">
      <v-layout row wrap class="school-map-compare-button" id="school-map-compare-button" v-show="displayCompareButton">
        <v-flex xs12 class="content">
          <a href="#" @click.stop.prevent="initShowCompare">
            <v-flex class="compare-text">
              {{ $t('Compare schools') }}
            </v-flex>
            <v-flex>
              ({{ compareSchoolTotal }}/6)
            </v-flex>
          </a>
        </v-flex>
      </v-layout>
      </div>

      <!-- Desktop -->
      <div v-show="!isMobile">
        <v-layout row wrap class="school-map-compare-bar" id="school-map-compare-bar" v-show="displayCompareButton">
          <a href="#" @click.stop.prevent="closeCompareBar" class="close">{{ $t('Close') }} <i class="material-icons">close</i></a>
          <v-flex xs3 class="compare-text">
            {{ $t('Compare schools') }}
            <div>({{ compareSchoolTotal }}/6)</div>
          </v-flex>
          <v-flex xs6>
            <div class="items-to-compare">
              <div class="list">
                <div class="list-item" v-for="(school, index) in schoolsToCompare" :key="index" >
                  <i @click.stop.prevent="removeSchoolFromCompare(school)" class="material-icons">close</i>
                  {{ school.name }}
                </div>
              </div>
            </div>
          </v-flex>
          <v-flex xs2 class="compare-now">
            <a href="#" @click.stop.prevent="initShowCompare" class="compare-now">  {{ $t('Compare now') }} </a>
          </v-flex>
        </v-layout>
      </div>
    </div>
  </div>
</template>

<script>
import SchoolMapSearch from '@/components/SchoolMap/SchoolMapSearch';
import SchoolMapView from '@/components/SchoolMap/SchoolMapView';
import SchoolListView from '@/components/SchoolMap/SchoolListView';
import SchoolCompare from '@/components/SchoolMap/SchoolCompare';
import RepositoryFactory from '@/services/RepositoryFactory';
const SchoolService = RepositoryFactory.get('schools');

export default {
  name: 'SchoolMap',
  components: {
    SchoolMapSearch,
    SchoolMapView,
    SchoolListView,
    SchoolCompare
  },
  data() {
    return {
      fetchedSchools: [],
      isMobile: false,
    }
  },
  methods: {
    async initShowCompare() {
      document.getElementsByClassName('application--wrap')[0].classList = 'application--wrap loading';
      await this.fetchSchoolsToCompare();
      setTimeout(() => {
        this.showCompare = true;
        document.getElementsByClassName('application--wrap')[0].classList = 'application--wrap';
      }, 1);
    },
    async fetchSchoolsToCompare() {
      let schools = await this.$store.state.compareSchool;
       await this.fetchSchools(schools);
    },
    async fetchSchools(schools) {
      let vm = this;
      await this.asyncForEach(schools, async (school) => {
        /*console.info({
          "element-model": 'school-map-compare-button',
          "action: ": "Click on compare button",
          "request": `Get School By ID: ${school.id}`,
          time: Math.floor(Date.now() / 1000)
        },"EVENT");*/
        vm.fetchedSchools[school.id] = await SchoolService.getById(school.id, school.level, school.province);
      });
    },
    async asyncForEach(array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
      }
    },
    removeSchoolFromCompare(school) {
      let schoolsInStore = this.$store.state.compareSchool;
      let results = schoolsInStore.filter(item => item.id != school.id);
      this.$store.commit("SET_COMPARE_SCHOOL", results);
    },
    checkIsMobile() {
      this.isMobile = parseInt(document.documentElement.clientWidth) < 960;
    },
    closeCompareBar() {
      this.$store.commit("SET_COMPARE_SCHOOL", []);
    }
  },
  mounted() {
    let mapViewWrapper = document.getElementById("school-map-wrapper");
    let compareSchool = document.getElementById("school-map-compare-button");
    window.onscroll = function() {
      if (window.innerHeight > mapViewWrapper.getBoundingClientRect().bottom) {
        compareSchool.classList.add('stick');
      }
      else {
        compareSchool.classList.remove('stick');
      }
    };
    window.addEventListener('resize', this.checkIsMobile);
    this.checkIsMobile();
  },
  computed: {
    schoolsToCompare() {
      return this.$store.state.compareSchool;
    },
    switchMapList: {
      get() {
        return this.$store.state.switcherMapList == 'map';
      }
    },
    compareSchoolTotal() {
      let compare_button = document.getElementsByClassName("school-map-compare-button");
      if (compare_button[0] != undefined) {
        compare_button[0].style.background="white";
        // eslint-disable-next-line
        setTimeout(() => {
          compare_button[0].style.background="#008485";
        }, 200);
      }
      return this.$store.state.compareSchool.length;
    },
    displayCompareButton() {
      return this.$store.state.compareSchool.length > 0;
    },
    showCompare: {
      get: function() {
        return this.$store.state.dialogCompareSchool;
      },
      set: function(value) {
        this.$store.commit("SET_DIALOG_COMPARE_SCHOOL", value);
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkIsMobile);
  }
}
</script>

